export function isPersonExecutive(companyRoleId: number): boolean {
  // According to https://api.merk.cz/docs/#!/enums
  const possibleExecutiveRoleIds = [1602, 40, 35, 33, 32, 14, 5, 1];
  return possibleExecutiveRoleIds.includes(companyRoleId);
}
